import React, { memo } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';

import logo from './logo.svg';

import {
  Wrapper,
  Container,
  Title,
  Content,
  CantLoad,
  Status,
  Button,
} from './ErrorPage.styled';

const ErrorPage = () => {
  const forceRefresh = () => {
    window.location.reload();
  };

  return (
    <Wrapper data-testid="error-page">
      <Container>
        <img src={logo} alt="Aula" />
        <Title>Something went wrong</Title>
        <Content>
          Error code: 500
          <CantLoad>
            Couldn’t load Aula. Please try again in a few minutes.
            <br />
            You can also check{' '}
            <Status href="https://aulaeducation.statuspage.io/" target="_blank">
              Aula’s status here <LaunchIcon />
            </Status>
          </CantLoad>
          <Button onClick={forceRefresh}>Retry to load</Button>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default memo(ErrorPage);
